import React from 'react';
import './style.scss';
import {Coins} from '../Coins';
import profileCardDefault from '../../../images/profile-card-default.png';
import { telegramMock } from 'telegram.consts';
const webApp = window.Telegram.WebApp;

export const ProfileCard = ({photo, coins, subscribed}) => {
  return <figure className="app-profile-card">
    <img src={photo || profileCardDefault} alt={''} className="app-profile-card--image" />
    <figcaption><Coins coins={coins} big={true}/></figcaption>
    {!subscribed && <div className="app-profile-card--warning">
      Хочешь, чтобы твои баллы сохранились в&nbsp;рейтинге?<br/>
      Просто подпишись на <a onClick={() => webApp.openTelegramLink('https://t.me/tv3russia')}>канал ТВ-3</a>, и&nbsp;ты&nbsp;в&nbsp;игре!&nbsp;😉
    </div>}
  </figure>;
}